import { createContext } from 'react';

import { State, createState } from '@hookstate/core';

import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesLoading } from './Updates.loading';
import { UpdatesError } from './Updates.error';
import { UpdatesDismissedRaw } from './UpdatesDismissed.raw';

export type SortUpdatesDismissedTypes =
  | 'assignee'
  | 'priority'
  | 'subject'
  | 'affects'
  | 'date'
  | 'count'
  | 'pManufacturers'
  | undefined;

export type DirectionUpdatesDismissedtypes = 'ASC' | 'DESC' | undefined;

interface IUpdatesDismissedContext {
  search: State<string>;
  sort: State<SortUpdatesDismissedTypes>;
  direction: State<DirectionUpdatesDismissedtypes>;
}

export const UpdatesDismissedContext = createContext<IUpdatesDismissedContext>({
  search: createState<string>(''),
  sort: createState<SortUpdatesDismissedTypes>(undefined),
  direction: createState<DirectionUpdatesDismissedtypes>(undefined),
});

interface IUpdatesDismissedQuery {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesDismissedQuery = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesDismissedQuery) => {
  if (isLoading || !data) {
    return <UpdatesLoading />;
  }

  if (isError) {
    return <UpdatesError />;
  }

  return (
    <UpdatesDismissedRaw
      updateStatuses={data}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesDismissedQuery };
